<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
// import { ModelListSelect } from "vue-search-select";
import Loader from "@/components/widgets/preloader";
import { mapGetters,mapActions,mapState } from "vuex"
import moment from "moment";
import axios from "axios";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Creditors Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    // ModelListSelect,
    Loader,
  },
  data() {
    return {
      title: "Credit Purchases Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Creditors Report",
          active: true,
        },
      ],
      totalRows: 1,
      filterTitle: 'Credit Purchases',
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      filteredReport:[],
      totals:{
        totalAmount:0,
        totalPaid:0,
        totalDiscount:0,
      },
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "details",
          sortable: true,
          label: "PRODUCTS",
        },
        {
          key: "tt_amt",
          sortable: true,
          label: "TOTAL",
        },
        {
          key: "amt_paid",
          sortable: true,
          label: "PAID",
        },
        {
          key: "discount_field",
          sortable: true,
          label: "DISCOUNT",
        },
        {
          key: "balance_field",
          sortable: true,
          label: "BALANCE",
        },
        {
          key: "supplier",
          sortable: true,
          label: "SUPPLIER",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        }
      ],
      fields1: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "details",
          sortable: true,
          label: "PRODUCTS",
        },
        {
          key: "tt_amt",
          sortable: true,
          label: "TOTAL",
        },
        {
          key: "amt_paid",
          sortable: true,
          label: "PAID",
        },
        {
          key: "discount_field",
          sortable: true,
          label: "DISCOUNT",
        },
        {
          key: "balance_field",
          sortable: true,
          label: "BALANCE",
        },
        {
          key: "supplier",
          sortable: true,
          label: "SUPPLIER",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "branch",
          sortable: true,
          label: "BRANCH",
        }
      ],
      data: {
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        datefrom: "",
      },

    };
  },
  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("purchase", ["SaveStatus","Creditors"]),
    ...mapGetters("setting", ["PaymentOptions","GeneralSettings"]),
    ...mapGetters("auth", ["business","branch","branchid"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.filteredReport ? this.filteredReport.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.filteredReport ? this.filteredReport.length : 1;
  },
  methods: {
    ...mapActions({
      FetchCreditors: "purchase/fetchCreditors",
      ClearBalance: "purchase/ClearCredit",
      FetchModes: "setting/fetchPaymentOptions",
      FetchGeneralSettings: "setting/fetchGeneralSettings",

    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    
    CreditorsData(){
      this.filteredReport = this.Creditors;
      let total_amount = 0;
      let total_paid = 0;
      let total_discount = 0;
      this.filteredReport.forEach((item)=>{
        total_amount = total_amount+parseInt(item.totAmt);
        total_paid = total_paid+parseInt(item.amtPaid);
        total_discount = total_discount+parseInt(item.discount);

        this.totals.totalBalance = this.totals.totalAmount-(this.totals.totalPaid+this.totals.totalDiscount);
      });
      this.totals.totalPaid = total_paid;
      this.totals.totalAmount = total_amount;
      this.totals.totalDiscount = total_discount;  
      this.totals.totalBalance = total_amount-(total_paid+total_discount)
    },
    filterReport() {      
      let date2 = this.data.dateto;
      let date1 = this.data.datefrom;
      let totalamount = 0;
      let totalpaid = 0;
      let totaldiscount = 0;
      this.filteredReport = this.Creditors.filter((element) => {
        if (
          this.data.datefrom != "" &&
          this.data.dateto != ""
        ) {
          this.filterTitle =
            "Creditors Report From " + this.data.datefrom + " To " + this.data.dateto;
          if (element.date >= date1 && element.date <= date2) {            
            let amt = parseInt(element.totAmt);
            totalamount = totalamount + amt;
            this.totals.totalAmount = totalamount;

            let paid = parseInt(element.amtPaid);
            totalpaid = totalpaid + paid;
            this.totals.totalPaid = totalpaid;

            let discount = parseInt(element.discount);
            totaldiscount = totaldiscount + discount;
            this.totals.totalDiscount = totaldiscount;

            return element.date >= date1 && element.date <= date2;
          }else if(this.totals.totalAmount == 0) {
            this.totals.totalAmount = 0;
            this.totals.totalPaid = 0;
            this.totals.totalDiscount = 0;
          }
        }
      });
    },

    
    Excel_export() {
      axios
        .post("export_creditors", this.data,{
          responseType: "arraybuffer",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "creditors_report.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          this.spinner = false;
        })
        .catch(() => {
        });
    },
  },

  watch: {
    Creditors(newValue){
      if(newValue){
        this.CreditorsData();
      }
    }
  },  
  created() {
    this.FetchCreditors();
    this.CreditorsData();
    this.FetchGeneralSettings();
  },
};
</script>

<template>
  <Layout>
    <div class="row py-3 text-center">
      <h4 v-if="GeneralSettings.show_businessname == 1" class="text-primary">{{business}}</h4><h4 v-if="GeneralSettings.show_branchname == 1 && branch"> <em  v-if="GeneralSettings.show_branchname == 1 && GeneralSettings.show_businessname == 1">-</em> {{branch}}</h4>
    </div>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div v-if="filterTitle">
                <h4>
                  <center>{{ filterTitle }}</center>
                </h4>
              </div>
              <div class="col-4">
                <b-button variant="info" @click="Excel_export()"
                  ><i class="fa fa-download"></i>Export</b-button>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label>From</label>
                  <input
                    @change="filterReport()"
                    type="date"
                    v-model="data.datefrom"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label>To</label>
                  <input
                    @change="filterReport()"
                    type="date"
                    v-model="data.dateto"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="filteredReport?filteredReport:[]"
                  :fields="branchid==0?fields1:fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(tt_amt)="data">
                  {{ (data.item.totAmt).toLocaleString() }}
                </template>
                <template #cell(amt_paid)="data">
                    {{ (data.item.amtPaid).toLocaleString() }}
                </template>
                <template #cell(discount_field)="data">
                  {{ (data.item.discount).toLocaleString() }}
                </template>
                <template #cell(balance_field)="data">
                  {{ (data.item.totAmt-(data.item.amtPaid+data.item.discount)).toLocaleString() }}
                </template>
                <template #cell(details)="data">
                  <p v-for="(det,d) in data.item.items" :key="d">{{ det.product }},</p> 
                </template>
              </b-table>
              <div class="row">
                  <div class="col-md-3">
                    <h5>Total Amount: <span class="text-danger">{{(totals.totalAmount).toLocaleString()}}</span></h5>
                  </div>
                  <div class="col-md-3">
                    <h5>Total Paid: <span class="text-danger">{{(totals.totalPaid).toLocaleString()}}</span></h5>
                  </div>
                  <div class="col-md-3">
                    <h5>Total Discount: <span class="text-danger">{{(totals.totalDiscount).toLocaleString()}}</span></h5>
                  </div>
                  <div class="col-md-3">
                    <h5>Total Balance: <span class="text-danger">{{(totals.totalAmount-(totals.totalPaid+totals.totalDiscount)).toLocaleString()}}</span></h5>
                  </div>
              </div>
            </div>
            <Loader  v-if="!Creditors"/>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
